import Vue from 'vue'

export default {
  setGuestToken: (state, payload) => {
    state.guestToken = payload
  },

  updateUserData: (state, payload) => {
    Object.entries(payload).forEach(([i, val]) => {
      Vue.set(state.user, i, val)
    })
  },

  setLoading: (state, payload) => {
    state.loading = payload
  },

  updateDashboardStatistics: (state, payload) => {
    Object.entries(payload).forEach(([i, val]) => {
      Vue.set(state.dashboard.statistics, i, val)
    })
  },

  updateCandidatesPagination: (state, payload) => {
    state.candidates.pagination.totalItems = payload.totalItems
    state.candidates.pagination.currentPage = payload.currentPage
  },

  candidatesData: (state, payload) => {
    state.candidates.data = payload
  },

  updateRecruitersPagination: (state, payload) => {
    state.recruiters.pagination.totalItems = payload.totalItems
    state.recruiters.pagination.currentPage = payload.currentPage
  },

  recruitersData: (state, payload) => {
    state.recruiters.data = payload
  },

  profilePositionsData: (state, payload) => {
    state.profilePositions.data = payload
  },

  activateUserAccount: (state, payload) => {
    const pool = payload.isRecruiter ? state.recruiters.data : state.candidates.data
    const index = pool.findIndex(u => u.id === payload.id)

    Vue.set(pool[index], 'activated', true)
  },

  updateRecruiterProfile: (state, payload) => {
    const index = state.recruiters.data.findIndex(u => u.id === payload.id)
    delete payload.id

    Object.entries(payload).forEach(([i, val]) => {
      Vue.set(state.recruiters.data[index].profile, i, val)
    })
  },

  matchmakingPositionData: (state, payload) => {
    state.matchmaking.positions = payload
  },

  origins: (state, payload) => {
    state.origins = payload
  }
}
